import type { myFetchOptions } from './request';
export const $api_Category_GetCategorys = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Category/GetCategorys', opt)
}
